import { isValidElement, useRef } from 'react';
import { OptionHeader, OptionHeaderProps } from '../OptionHeader';
import { Divider } from '../Divider';

export type OptionProps = {
	isActive: boolean;
	header: Omit<OptionHeaderProps, 'active'> | JSX.Element;
	children?: JSX.Element[] | JSX.Element
};

export const Option: React.FC<OptionProps > = ({
	isActive,
	header,
	children
}) => {
	const ref = useRef<HTMLDivElement>(null);

	let headerToRender: React.ReactNode;

	if (isValidElement(header)) {
		headerToRender = header;
	} else {
		const headerProps = header as OptionHeaderProps;

		headerToRender = <OptionHeader {...headerProps} active={isActive} />;
	}

	return (
		<div className="option">
			{headerToRender}

			<div
				style={{
					overflow: 'hidden',
					marginLeft: -5,
					paddingLeft: 5,
					marginRight: -5,
					paddingRight: 5,
					height: isActive
						? `${
								ref.current?.clientHeight
									? String(ref.current?.clientHeight) + 'px'
									: 'auto'
							}`
						: '0px',
					transition: 'height .7s ease'
				}}
			>
				<div className="pb-3" ref={ref}>
					<Divider mt={0} />

					{children}
				</div>
			</div>

			<Divider my={0} />
		</div>
	);
};
